module.exports = __webpack_public_path__ + "static/media/learn-coding-video.2f1de84f.png";